export const de = {
  'Unknown': 'Unbekannt',
};
